var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 125,
    viewBox: "0 0 83 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9671 93.7209C27.9122 83.5192 26.3592 81.6152 28.1928 79.0121C28.4032 78.7132 29.4792 77.1866 31.4153 76.6565C32.9581 76.2344 34.4234 76.616 35.1284 76.9402C39.4129 78.9116 39.0473 89.0563 36.889 95.6231C36.4183 97.0549 35.1563 100.896 33.2287 100.97C32.4391 101 31.8032 100.388 31.3556 99.9452C29.3768 97.9885 29.1261 95.2593 28.9671 93.7209Z",
    fill: "url(#paint0_linear_1411_10924)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7441 3.68457H48.6387V17.5004H50.7441V3.68457Z",
    fill: "url(#paint1_linear_1411_10924)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.962 25.1308H42.4217C41.3494 25.1308 40.4805 24.2618 40.4805 23.1896V17.993C40.4805 16.9207 41.3494 16.0518 42.4217 16.0518H56.962C58.0343 16.0518 58.9033 16.9207 58.9033 17.993V23.1896C58.9028 24.2618 58.0339 25.1308 56.962 25.1308Z",
    fill: "url(#paint2_linear_1411_10924)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6521 55.329C82.6521 63.7221 75.8477 70.5264 67.4546 70.5264H31.9279C23.5692 70.5264 16.7305 63.6877 16.7305 55.329V47.4344C16.7305 32.5626 28.8982 20.3945 43.7703 20.3945H55.6127C70.4844 20.3945 82.6525 32.5622 82.6525 47.4344L82.6521 55.329Z",
    fill: "url(#paint3_linear_1411_10924)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2834 53.8902C71.4209 54.3165 70.4539 54.54 69.4715 54.54H29.9116C28.9292 54.54 27.9622 54.3165 27.0997 53.8902C24.981 52.8428 23.7854 50.728 24.0845 48.5586L24.1065 48.4009C25.1203 41.0525 31.7755 35.4029 39.9348 34.9783C43.387 34.7987 47.0099 34.7059 50.7887 34.7278C53.7489 34.745 56.6102 34.8318 59.3654 34.9736C67.5557 35.3956 74.2599 41.0228 75.2775 48.3992C75.2848 48.452 75.2921 48.5053 75.2994 48.5582C75.5981 50.728 74.4021 52.8428 72.2834 53.8902Z",
    fill: "url(#paint4_linear_1411_10924)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2644 52.9223C43.3843 52.9223 46.7241 49.5825 46.7241 45.4626C46.7241 41.3428 43.3843 38.0029 39.2644 38.0029C35.1445 38.0029 31.8047 41.3428 31.8047 45.4626C31.8047 49.5825 35.1445 52.9223 39.2644 52.9223Z",
    fill: "url(#paint5_radial_1411_10924)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2645 50.818C42.2216 50.818 44.6188 48.4208 44.6188 45.4637C44.6188 42.5066 42.2216 40.1094 39.2645 40.1094C36.3074 40.1094 33.9102 42.5066 33.9102 45.4637C33.9102 48.4208 36.3074 50.818 39.2645 50.818Z",
    fill: "#EEFDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2645 49.9598C41.7482 49.9598 43.7615 47.9464 43.7615 45.4628C43.7615 42.9792 41.7482 40.9658 39.2645 40.9658C36.7809 40.9658 34.7676 42.9792 34.7676 45.4628C34.7676 47.9464 36.7809 49.9598 39.2645 49.9598Z",
    fill: "url(#paint6_linear_1411_10924)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1459 44.2976C42.1459 45.2177 41.4003 45.9633 40.4802 45.9633C39.5601 45.9633 38.8145 45.2173 38.8145 44.2976C38.8145 43.3779 39.5601 42.6318 40.4802 42.6318C41.4003 42.6318 42.1459 43.3779 42.1459 44.2976Z",
    fill: "#EEFDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6004 49.5758C38.9676 49.5758 39.2652 49.2781 39.2652 48.9109C39.2652 48.5437 38.9676 48.2461 38.6004 48.2461C38.2332 48.2461 37.9355 48.5437 37.9355 48.9109C37.9355 49.2781 38.2332 49.5758 38.6004 49.5758Z",
    fill: "#EEFDFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9515 47.9123C36.9515 48.0958 36.8028 48.2445 36.6193 48.2445C36.4358 48.2445 36.2871 48.0958 36.2871 47.9123C36.2871 47.7288 36.4358 47.5801 36.6193 47.5801C36.8028 47.5801 36.9515 47.7292 36.9515 47.9123Z",
    fill: "#EEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4167 52.9223C63.5366 52.9223 66.8764 49.5825 66.8764 45.4626C66.8764 41.3428 63.5366 38.0029 59.4167 38.0029C55.2969 38.0029 51.957 41.3428 51.957 45.4626C51.957 49.5825 55.2969 52.9223 59.4167 52.9223Z",
    fill: "url(#paint7_radial_1411_10924)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4168 50.818C62.374 50.818 64.7712 48.4208 64.7712 45.4637C64.7712 42.5066 62.374 40.1094 59.4168 40.1094C56.4597 40.1094 54.0625 42.5066 54.0625 45.4637C54.0625 48.4208 56.4597 50.818 59.4168 50.818Z",
    fill: "#EEFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4169 49.9598C61.9005 49.9598 63.9139 47.9464 63.9139 45.4628C63.9139 42.9792 61.9005 40.9658 59.4169 40.9658C56.9333 40.9658 54.9199 42.9792 54.9199 45.4628C54.9199 47.9464 56.9333 49.9598 59.4169 49.9598Z",
    fill: "url(#paint8_linear_1411_10924)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2987 44.2976C62.2987 45.2177 61.5526 45.9633 60.633 45.9633C59.7133 45.9633 58.9668 45.2173 58.9668 44.2976C58.9668 43.3779 59.7129 42.6318 60.633 42.6318C61.5531 42.6318 62.2987 43.3779 62.2987 44.2976Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7527 49.5748C59.1199 49.5748 59.4176 49.2771 59.4176 48.9099C59.4176 48.5428 59.1199 48.2451 58.7527 48.2451C58.3856 48.2451 58.0879 48.5428 58.0879 48.9099C58.0879 49.2771 58.3856 49.5748 58.7527 49.5748Z",
    fill: "#EEFDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1039 47.9123C57.1039 48.0958 56.9552 48.2445 56.7717 48.2445C56.5882 48.2445 56.4395 48.0958 56.4395 47.9123C56.4395 47.7288 56.5882 47.5801 56.7717 47.5801C56.9552 47.5801 57.1039 47.7292 57.1039 47.9123Z",
    fill: "#EEFDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3889 2.76301C52.3889 4.25254 51.1813 5.46059 49.6913 5.46059C48.2018 5.46059 46.9941 4.25297 46.9941 2.76301C46.9941 1.27347 48.2018 0.0654297 49.6913 0.0654297C51.1813 0.0654297 52.3889 1.27304 52.3889 2.76301Z",
    fill: "url(#paint9_linear_1411_10924)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.567 1.71025C51.567 2.1645 51.1987 2.53237 50.7444 2.53237C50.2902 2.53237 49.9219 2.16407 49.9219 1.71025C49.9219 1.256 50.2902 0.887695 50.7444 0.887695C51.1987 0.888125 51.567 1.256 51.567 1.71025Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9161 29.0428C72.9518 30.3019 71.9238 31.8082 70.7463 31.9367C69.6427 32.0575 68.7612 30.9298 67.8523 29.7669C66.9562 28.6207 64.997 25.6761 65.7774 24.8432C66.8058 23.7452 72.8314 26.0719 72.9161 29.0428Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8338 24.2437C63.3514 24.2437 63.7711 23.8241 63.7711 23.3064C63.7711 22.7888 63.3514 22.3691 62.8338 22.3691C62.3161 22.3691 61.8965 22.7888 61.8965 23.3064C61.8965 23.8241 62.3161 24.2437 62.8338 24.2437Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7828 46.5124C72.482 46.7247 70.3852 42.4529 64.7563 38.7492C62.7777 37.4471 60.8244 36.5192 60.9405 36.2494C61.0582 35.9756 63.2581 36.4849 65.0193 37.3018C70.631 39.9053 73.1404 46.2601 72.7828 46.5124Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3682 18.7405C58.3012 18.7499 58.2582 18.3558 57.9299 17.7469C57.9299 17.7469 57.7765 17.4619 57.6011 17.2204C57.036 16.4426 55.1201 16.4598 54.9697 16.461C51.9859 16.4868 50.0675 16.2977 50.0684 16.3158C50.0688 16.3308 51.4681 16.3025 52.4935 16.2818C55.3862 16.223 57.1095 16.0674 57.8482 16.8422C58.1546 17.1637 58.3089 17.5823 58.3089 17.5823C58.5178 18.1504 58.4482 18.7289 58.3682 18.7405Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7479 57.7414C57.6748 58.456 57.08 59.0066 56.3649 59.0753L46.4831 60.0281C45.7684 60.0969 45.0791 59.671 44.8707 58.9834C44.7778 58.6778 44.7065 58.3628 44.6579 58.0387C44.6446 57.9494 44.6682 57.8583 44.7241 57.7865C44.78 57.7151 44.8625 57.67 44.9527 57.661L57.4195 56.4585C57.5085 56.4499 57.5966 56.4783 57.6641 56.5368C57.7315 56.5952 57.7715 56.679 57.7754 56.768C57.7904 57.0976 57.7805 57.4225 57.7479 57.7414Z",
    fill: "#EEFDFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7489 57.7422C57.4331 60.8055 54.9976 63.3239 51.8161 63.6277C48.6781 63.9315 45.8438 61.9856 44.9121 59.1041C45.1609 59.7199 45.8082 60.0951 46.4833 60.0276L56.3677 59.0762C57.0819 59.0052 57.6741 58.4564 57.7489 57.7422Z",
    fill: "url(#paint10_linear_1411_10924)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3187 79.9356C73.3187 80.0263 73.3187 80.1131 73.3148 80.196C73.2834 81.025 73.0896 81.6486 72.9951 81.9288C70.2751 90.2381 68.6451 94.6199 66.3596 98.1645C65.9651 98.7765 65.5504 99.3644 65.1043 99.9407C64.5203 100.71 63.8808 101.46 63.17 102.234C61.5911 103.952 59.2029 104.729 58.4332 104.998C55.6187 105.993 53.1317 105.811 51.478 105.827H51.1897C49.5317 105.811 47.049 105.993 44.2345 104.998C43.4648 104.729 41.0728 103.952 39.4977 102.234C35.1555 97.5092 33.4859 93.5816 29.6726 81.9288C29.582 81.6606 29.4002 81.08 29.3568 80.3026C29.3452 80.0774 29.3409 79.8526 29.3529 79.6274C29.4358 78.2342 30.0001 76.868 31.0032 75.6208C32.7205 73.4815 35.3729 72.3091 38.1165 72.2971L51.3362 72.2417L64.3153 72.1905C67.1181 72.1785 69.8338 73.3552 71.6138 75.522C72.4746 76.5719 73.023 77.7047 73.2245 78.8732C73.2521 79.0391 73.2757 79.2089 73.2916 79.3747C73.3066 79.5604 73.3187 79.7461 73.3187 79.9356Z",
    fill: "url(#paint11_linear_1411_10924)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3329 72.2436L38.1132 72.299C35.3696 72.3111 32.7172 73.4835 30.9999 75.6228C29.9973 76.8704 29.433 78.2361 29.3496 79.6294C29.4167 78.2005 30.005 76.799 31.051 75.5239C32.8272 73.3567 35.5471 72.1804 38.3496 72.1925L51.3329 72.2436Z",
    fill: "url(#paint12_linear_1411_10924)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4725 91.7205C64.2796 81.4661 62.8919 79.438 64.9384 76.9987C65.1735 76.7185 66.3738 75.2879 68.3476 74.9226C69.9206 74.6316 71.3482 75.1353 72.0238 75.5178C76.1271 77.8424 74.9096 87.9206 72.2064 94.2827C71.6172 95.6699 70.0361 99.3912 68.1091 99.3022C67.3197 99.2657 66.7373 98.6022 66.3291 98.1238C64.5219 96.0073 64.5018 93.2663 64.4725 91.7205Z",
    fill: "url(#paint13_linear_1411_10924)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3596 98.1647C65.9651 98.7767 65.5504 99.3646 65.1043 99.9409C64.9621 99.7948 64.8357 99.6487 64.7214 99.5146C62.9134 97.3989 62.8937 94.6592 62.8661 93.1121C62.6728 82.8568 61.2834 80.8318 63.332 78.3921C63.482 78.2107 64.0308 77.5592 64.923 77.0186C62.9018 79.4501 64.2796 81.4949 64.473 91.7188C64.5005 93.2659 64.5241 96.0056 66.3283 98.1256C66.3399 98.1372 66.3519 98.1488 66.3596 98.1647Z",
    fill: "url(#paint14_linear_1411_10924)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1451 83.1799C72.087 82.078 71.8803 81.2679 71.4669 79.6469C70.9263 77.5265 70.2481 76.4929 70.6886 76.0834C70.9753 75.8169 71.54 75.997 71.668 76.0378C73.6062 76.6562 74.2062 80.2924 74.1228 82.5679C74.0717 83.9612 73.7317 85.5191 73.2212 85.5878C73.1408 85.5986 72.9405 85.5883 72.7974 85.4615C72.2276 84.9583 72.1893 84.0175 72.1451 83.1799Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4764 87.0702C73.4764 87.2924 73.2963 87.4725 73.0741 87.4725C72.8519 87.4725 72.6719 87.2924 72.6719 87.0702C72.6719 86.848 72.8519 86.668 73.0741 86.668C73.2963 86.668 73.4764 86.848 73.4764 87.0702Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7424 124.35C62.3891 124.35 71.8306 120.484 71.8306 115.716C71.8306 110.948 62.3891 107.083 50.7424 107.083C39.0958 107.083 29.6543 110.948 29.6543 115.716C29.6543 120.484 39.0958 124.35 50.7424 124.35Z",
    fill: "url(#paint15_radial_1411_10924)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49227 20.5113C1.49227 20.5113 0.676164 13.1199 1.08185 12.9184C1.48754 12.7172 1.6805 16.7544 1.49227 20.5113Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1411_10924",
    x1: 32.7407,
    y1: 86.2164,
    x2: 46.643,
    y2: 39.6744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06BED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1411_10924",
    x1: 45.4007,
    y1: 11.2182,
    x2: 51.7166,
    y2: 10.2971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1411_10924",
    x1: 43.7901,
    y1: 27.2544,
    x2: 54.9985,
    y2: 14.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1411_10924",
    x1: 27.5554,
    y1: 71.088,
    x2: 71.97,
    y2: 26.6734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1411_10924",
    x1: 49.5746,
    y1: 54.4759,
    x2: 49.9694,
    y2: 36.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1411_10924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2642 45.4626) scale(7.38253 7.38252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1411_10924",
    x1: 34.7672,
    y1: 45.4627,
    x2: 43.7615,
    y2: 45.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1411_10924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4167 45.4626) scale(7.38252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1411_10924",
    x1: 54.9197,
    y1: 45.4627,
    x2: 63.9139,
    y2: 45.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1411_10924",
    x1: 44.0133,
    y1: 3.59089,
    x2: 52.3718,
    y2: 2.37193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1411_10924",
    x1: 49.4209,
    y1: 61.3754,
    x2: 62.2805,
    y2: 48.5159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#0DA9AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1411_10924",
    x1: 37.2761,
    y1: 100.399,
    x2: 71.3475,
    y2: 60.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0408,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1607,
    stopColor: "#37D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    stopColor: "#5DE0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3793,
    stopColor: "#78E6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4719,
    stopColor: "#88E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5423,
    stopColor: "#8EEAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8004,
    stopColor: "#B9F39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1411_10924",
    x1: 35.4706,
    y1: 80.563,
    x2: 55.9598,
    y2: 56.6369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1411_10924",
    x1: 79.4953,
    y1: 94.4581,
    x2: 53.9853,
    y2: 75.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#0FD1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#67E2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    stopColor: "#A7EFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "#CFF795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1411_10924",
    x1: 57.0147,
    y1: 92.6483,
    x2: 75.0937,
    y2: 83.2268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06BED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1411_10924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7425 115.717) scale(21.0881 8.63319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.01c43902f83d8994b76ae1a681e7b2a0.svg";
export { ForwardRef as ReactComponent };